import { Injectable, signal } from '@angular/core';
import { LanguageModel } from '../api/models/language-model';

const DEFAULT_LANGUAGE: LanguageModel = {
  name: 'English',
  code: 'en',
};

@Injectable({
  providedIn: 'root',
})
export class TranslationEventService {
  selectedLanguage = signal<LanguageModel>(DEFAULT_LANGUAGE);

  reset(): void {
    this.selectedLanguage.set(DEFAULT_LANGUAGE);
  }
}
